import {
  CLEAR_FOLLOWERS,
  CLEAR_FOLLOWINGS,
  DELETE_FOLLOWER_SUCCESS,
  GET_FOLLOWERS,
  GET_FOLLOWERS_FAILED,
  GET_FOLLOWERS_SUCCESS,
  GET_FOLLOWINGS,
  GET_FOLLOWINGS_FAILED,
  GET_FOLLOWINGS_SUCCESS,
  SUBSCRIBE_SUCCESS,
} from '../constants';

import { FollowersStoreType, SubscriberType } from 'types/stateTypes';
import { GetFollowersPayload, SubscribePayloadType } from 'redux/actions/followersActions';
import { ActionType } from 'types/reduxTypes';
import { idOnly } from 'utils/cls.utils';

const initialState: FollowersStoreType = {
  followers: [],
  followersPage: 1,
  followings: [],
  followingsPage: 1,
  hasMoreFollowers: false,
  hasMoreFollowings: false,
  loadingFollowers: false,
  loadingFollowings: false,
};

const deleteUser = (followers: typeof initialState.followers, user: SubscribePayloadType) =>
  followers.filter((person) => idOnly(person.rEntity) !== user.userId);

export default (state = initialState, action: ActionType<unknown>): FollowersStoreType => {
  switch (action.type) {
    case GET_FOLLOWINGS: {
      return { ...state, loadingFollowings: true };
    }
    case GET_FOLLOWINGS_FAILED: {
      return { ...state, loadingFollowings: false };
    }
    case GET_FOLLOWINGS_SUCCESS: {
      const { items, pageSize, page } = action.payload as GetFollowersPayload;
      const newState = {
        followings: [...state.followings, ...items],
        followingsPage: page + 1,
        hasMoreFollowings: items.length >= pageSize,
        loadingFollowings: false,
      };
      return { ...state, ...newState };
    }
    case GET_FOLLOWERS: {
      return { ...state, loadingFollowers: true };
    }
    case GET_FOLLOWERS_FAILED: {
      return { ...state, loadingFollowers: false };
    }
    case GET_FOLLOWERS_SUCCESS: {
      const { items, pageSize, page } = action.payload as GetFollowersPayload;
      const newState = {
        followers: [...state.followers, ...items],
        followersPage: page + 1,
        hasMoreFollowers: items.length >= pageSize,
        loadingFollowers: false,
      };
      return { ...state, ...newState };
    }
    case CLEAR_FOLLOWERS: {
      const { followers, followersPage, hasMoreFollowers, loadingFollowers } = initialState;
      return { ...state, followers, followersPage, hasMoreFollowers, loadingFollowers };
    }
    case CLEAR_FOLLOWINGS: {
      const { followings, followingsPage, hasMoreFollowings, loadingFollowings } = initialState;
      return { ...state, followings, followingsPage, hasMoreFollowings, loadingFollowings };
    }
    case DELETE_FOLLOWER_SUCCESS: {
      const user = action.payload as SubscribePayloadType;
      return {
        ...state,
        followers: [...state.followers.filter((person) => idOnly(person.rEntity) !== user.userId)],
      };
    }
    case SUBSCRIBE_SUCCESS: {
      const user = action.payload as SubscribePayloadType;
      const newFollowers = user.subscribed ? [...state.followers, user] : [...deleteUser(state.followers, user)];
      const newFollowings = user.isForeignProfile
        ? state.followings
        : user.subscribed
        ? [...state.followings, user]
        : [...deleteUser(state.followers, user)];
      return { ...state, followers: newFollowers as SubscriberType[], followings: newFollowings as SubscriberType[] };
    }

    default: {
      return state;
    }
  }
};
